var map = {
	"./Gallery_0.jpg": 532,
	"./Gallery_1.jpg": 7905,
	"./Gallery_2.jpg": 134,
	"./Gallery_3.jpg": 8659,
	"./Gallery_4.jpg": 7008,
	"./Gallery_5.jpg": 7933,
	"./Gallery_6.jpg": 8674,
	"./Gallery_7.jpg": 1343,
	"./Gallery_8.jpg": 3596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6011;